import { Box, TextField, Button, CircularProgress } from "@mui/material";
import { Control, Controller, useWatch } from "react-hook-form";
import { ScheduleActionFormData } from "./types";

type NotesUpdaterProps = {
    control: Control<ScheduleActionFormData>;
    isUpdatingNotes: boolean;
    onUpdateNotes: () => void;
    onCancel: () => void;
};

export const NotesUpdater = ({ control, isUpdatingNotes, onUpdateNotes, onCancel }: NotesUpdaterProps) => {
    const noteText = useWatch({
        control,
        name: "noteText",
    });

    return (
        <Box p={2}>
            <Controller
                name="noteText"
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        label="Nota"
                        multiline
                        rows={3}
                        size="small"
                        fullWidth
                        placeholder="Adicionar nota aos eventos selecionados..."
                        sx={{ mb: 2 }}
                    />
                )}
            />
            <Button
                fullWidth
                variant="contained"
                size="small"
                onClick={onUpdateNotes}
                disabled={isUpdatingNotes || !noteText?.trim()}
                sx={{ mb: 1 }}
            >
                {isUpdatingNotes ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
                Atualizar Notas
            </Button>
            <Button
                fullWidth
                color="secondary"
                size="small"
                onClick={onCancel}
            >
                Cancelar
            </Button>
        </Box>
    );
}; 